import { HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { SiaHttpService } from '@sia/shared';
import { MicrosoftTokenInfo } from '../../interfaces/MicrosoftTokenInfo';

@Injectable({
  providedIn: 'root',
})
export class MicrosoftAuthApi {
  private api = inject(SiaHttpService);

  private readonly controller: string = 'microsoft-token';

  async authEmail(tokenInfo: MicrosoftTokenInfo): Promise<string> {
    return await this.api.post(
      `${this.controller}/microsoft-mail-authentication`,
      tokenInfo,
    );
  }
  async logout(scope: string, email: string | undefined): Promise<string> {
    let controller = scope.startsWith('workflow')
      ? 'token-workflow'
      : this.controller;
    const url = `${controller}/token/${scope}`;
    const trimmed = (email || '').trim();
    if (trimmed) {
      const params = new HttpParams().set('email', trimmed);
      return this.api.delete(url, { params });
    }
    // If email is empty/undefined, don't send the query param at all
    return this.api.delete(url, {});
  }

  getOutlookConfig(): Promise<{ clientId: string; redirectUri: string }> {
    return this.api.get('token-workflow/outlook-config');
  }

  getMicrosoftLoginConfig(): Promise<{
    clientId: string;
    tenantId: string;
  } | null> {
    return this.api
      .get(`${this.controller}/login-config`, {})
      .catch(() => null);
  }

  loginWithMicrosoftIdToken(idToken: string, deviceInfo?: any): Promise<any> {
    return this.api.post(`${this.controller}/login`, {
      idToken,
      deviceInfo,
    });
  }
}
